import { render } from "./Student.vue?vue&type=template&id=476ddd4c&ts=true"
import script from "./Student.vue?vue&type=script&lang=ts"
export * from "./Student.vue?vue&type=script&lang=ts"

import "./Student.vue?vue&type=style&index=0&id=476ddd4c&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__